import React from 'react';
import { KnowledgeBaseManagement } from '../features/databases';

/**
 * DatabasesPage - Admin knowledge bases management page
 */
export const DatabasesPage: React.FC = () => {
  return <KnowledgeBaseManagement />;
};

export default DatabasesPage;
